module.exports = __webpack_public_path__ + "img/image_s3.68868150.png";